import pro1 from '../../resources/assets/tic-tac-toe.jpg'
import pro2 from '../../resources/assets/expense-manager.jpg'
import pro3 from '../../resources/assets/project3.jpg'
import pro5 from '../../resources/assets/project5.jpg'

const ProjectsData = [
    {
        imgsrc: pro1,
        title: "Tic-Tac-Toe",
        text: "Tic-Tac-Toe is a two-player game in which the players fill up nine empty rectangles in a table with either an X or an O when it is their turn. Once someone succeeds to line up their sign vertically, horizontally or diagonaly without an interruption, that player wins.",
        view: "/tic-tac-toe"
    },
    {
        imgsrc: pro2,
        title: "Expense manager",
        text: "As the name itself suggests, this project is an attempt to manage our daily expenses in a more efficient and manageable way.",
        view: "/expense-manager"
    },
    {
        imgsrc: pro3,
        title: "Login Page",
        text: `Login page : sign up and sign in`,
        view: "/login"
    },
    // {
    //     imgsrc: pro4,
    //     title: "Ecommerce website",
    //     text: `coming soon...`,
    //     view: "/crypto"
    // },
    {
        imgsrc: pro5,
        title: "Salary Calculator",
        text: `This is a simple salary calculator where we can calculate monthly salary based on total fixed ctc after tax deduction.`,
        view: "/salary-calculator"
    }
]

export default ProjectsData